import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "plan-cards-wrapper w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Retiree Profile"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-control plus" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "plus iatse-icon-plus" }),
    /*#__PURE__*/_createElementVNode("span", { class: "line" })
  ])
], -1)
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "data-section" }
const _hoisted_8 = { class: "fund-details" }
const _hoisted_9 = { class: "fund-detail" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Participant ID", -1)
const _hoisted_11 = { class: "fund-detail" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "SSN", -1)
const _hoisted_13 = { class: "fund-detail" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", null, "Name", -1)
const _hoisted_15 = { class: "fund-detail" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h5", null, "Age", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-20" }, "Spouse", -1)
const _hoisted_19 = { class: "data-section mt-5" }
const _hoisted_20 = { class: "fund-details" }
const _hoisted_21 = { class: "fund-detail" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h5", null, "SSN", -1)
const _hoisted_23 = { class: "fund-detail" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h5", null, "Name", -1)
const _hoisted_25 = { class: "fund-detail" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h5", null, "Age", -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "data-section" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", null, "Annual Totals", -1)
const _hoisted_30 = { class: "custom-table" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "table-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-row__header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "primary-row" }, [
      /*#__PURE__*/_createElementVNode("div", null, "Benefit"),
      /*#__PURE__*/_createElementVNode("div", null, "Part YTD"),
      /*#__PURE__*/_createElementVNode("div", null, "Spse YTD")
    ])
  ])
], -1)
const _hoisted_32 = { class: "table-row__header" }
const _hoisted_33 = { class: "primary-row" }
const _hoisted_34 = { class: "container-fluid" }
const _hoisted_35 = { class: "row mt-30" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "Retiree Benefits", -1)
const _hoisted_38 = { class: "custom-table" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "table-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-row__header" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "primary-row" }, [
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("button", { style: {"visibility":"hidden"} }, "+")
      ]),
      /*#__PURE__*/_createElementVNode("div", null, "Date"),
      /*#__PURE__*/_createElementVNode("div", null, "Check #"),
      /*#__PURE__*/_createElementVNode("div", null, "Amount"),
      /*#__PURE__*/_createElementVNode("div", null, "Payee"),
      /*#__PURE__*/_createElementVNode("div", null, "Run Date"),
      /*#__PURE__*/_createElementVNode("div", null, "Clear Date")
    ])
  ])
], -1)
const _hoisted_40 = { class: "table-row__header" }
const _hoisted_41 = { class: "primary-row" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 0,
  class: "table-row__content"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "secondary-row" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Person"),
  /*#__PURE__*/_createElementVNode("div", null, "Benefit"),
  /*#__PURE__*/_createElementVNode("div", null, "Period Reimbursed"),
  /*#__PURE__*/_createElementVNode("div", null, "Amount Req"),
  /*#__PURE__*/_createElementVNode("div", null, "Amount Paid"),
  /*#__PURE__*/_createElementVNode("div", null, "Comments")
], -1)
const _hoisted_45 = {
  key: 1,
  class: "table-row"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "table-row__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "primary-row" }, [
    /*#__PURE__*/_createElementVNode("div", null, "No records found.")
  ])
], -1)
const _hoisted_47 = [
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("h4", null, _toDisplayString($setup.personDetails.PersonID), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("h4", null, [
                    _createElementVNode("p", {
                      class: "plan-modal text-underline text-primary",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('recaptcha', 'Show SSN', 'modal-success')), ["prevent"]))
                    }, "Show SSN")
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("h4", null, _toDisplayString($setup.personDetails.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("h4", null, _toDisplayString($setup.personDetails.Age), 1)
                ])
              ])
            ]),
            ($setup.spouseDetails != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("p", {
                          class: "plan-modal text-underline text-primary",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.openModal('recaptcha', 'Show SSN', 'modal-success', null, {entity: $setup.spouseDetails.SSN , Type: 'Spouse' })), ["prevent"]))
                        }, "Show SSN")
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("h4", null, _toDisplayString($setup.spouseDetails.Name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("h4", null, _toDisplayString($setup.spouseDetails.Age), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.totals, (benefitData, benefitName) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "table-row",
                    key: benefitName
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", null, _toDisplayString(benefitName), 1),
                        _createElementVNode("div", null, _toDisplayString($setup.formatCurrency(benefitData.Participant ?? 0)), 1),
                        _createElementVNode("div", null, [
                          (benefitData.Spouse != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(benefitData.Spouse)), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" - ")
                              ], 64))
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              ($setup.retireeChecks.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.retireeChecks, (check, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "table-row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => ($setup.toggleDetails(index))
                            }, _toDisplayString($setup.openedIndexes.includes(index) ? '-' : '+'), 9, _hoisted_42)
                          ]),
                          _createElementVNode("div", null, _toDisplayString(check.CheckDate), 1),
                          _createElementVNode("div", null, _toDisplayString(check.CheckNumber), 1),
                          _createElementVNode("div", null, _toDisplayString($setup.formatCurrency(check.AmountPaid)), 1),
                          _createElementVNode("div", null, _toDisplayString(check.PaidTo), 1),
                          _createElementVNode("div", null, _toDisplayString(check.CheckRunDate), 1),
                          _createElementVNode("div", null, _toDisplayString(check.ClearDate), 1)
                        ])
                      ]),
                      ($setup.openedIndexes.includes(index))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _hoisted_44,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(check.Details, (personDetails, personID) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: personID }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(personDetails, (reimbursement, subIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "secondary-row",
                                    key: subIndex
                                  }, [
                                    _createElementVNode("div", null, _toDisplayString(reimbursement.PaidTo), 1),
                                    _createElementVNode("div", null, _toDisplayString(reimbursement.BenefitType), 1),
                                    _createElementVNode("div", null, _toDisplayString(reimbursement.PeriodReimbursedFor), 1),
                                    _createElementVNode("div", null, _toDisplayString($setup.formatCurrency(reimbursement.AmountRequested)), 1),
                                    _createElementVNode("div", null, _toDisplayString($setup.formatCurrency(reimbursement.AmountPaid)), 1),
                                    _createElementVNode("div", null, _toDisplayString(reimbursement.Notes), 1)
                                  ]))
                                }), 128))
                              ], 64))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
            ])
          ])
        ])
      ])
    ])
  ]))
}